import { SystemEntity } from '@erp/shared-types';

export interface TaskTypeOptionSource {
  key: string;
  name: string;
  anchorEntityType: string | null;
}

export interface TaskTypePickerOption {
  key: string;
  name: string;
}

/**
 * Task types a rule may pick: anchored to AP invoices and not taken by
 * another rule (its own current pick stays). `missingValue` is true when a
 * saved key is not among them — archived or re-anchored after saving.
 */
export function exceptionTaskTypeOptions(
  types: readonly TaskTypeOptionSource[],
  value: string,
  takenKeys: ReadonlySet<string>,
): { options: TaskTypePickerOption[]; missingValue: boolean } {
  const options: TaskTypePickerOption[] = [];
  for (const type of types) {
    if (type.anchorEntityType !== SystemEntity.AP_INVOICE) continue;
    if (type.key !== value && takenKeys.has(type.key)) continue;
    options.push({ key: type.key, name: type.name });
  }
  const missingValue =
    value.length > 0 && !options.some((option) => option.key === value);
  return { options, missingValue };
}
